VP = window.VP || {};

/*
 * Page Load Modifers
*/

(function( $ ) {
  VP.videoload = {
    $videos:null,
    init: function () {
      var _this = this;
      //_this.initlazyvideo();
      _this.$videos = $(".video-wrap");
      if (!_this.$videos.length) {
        return;
      }
      // console.log("[videoload] Found videos: " + _this.$videos.length);
      _this.eventHandlers();

      if (Cookies.get("videoplayback") == "paused") {
        $("body").addClass("paused");
      }
      
      // starts and stops all videos on page (for article stops)
      $(".videocontrols").on("click", function() {
        // console.log("click");
        // toggle video state
        _this.$videos.each(function() {
          var _vid = $(this).find("video").get(0);
          if ($("body").hasClass("paused") || $(this).hasClass("freeze")) {
            if (!$(this).hasClass("loading")) {
              _vid.play();
            }
          }
          else {            
            _vid.pause();
          }          
        });

        // toggle page state
        if ($("body").hasClass("paused")) {
          $("body").removeClass("paused");
          Cookies.set("videoplayback","playing");
        }
        else {
          $("body").addClass("paused");
          Cookies.set("videoplayback","paused");
        }
      });
    },
    eventHandlers: function() {
      var _this = this;        

      VP.documentEvents.onResize( _this.checkScrollPosition.bind( _this ), true );
      VP.documentEvents.onScroll( _this.checkScrollPosition.bind( _this ), true );
      setTimeout(function() {
        _this.checkScrollPosition();
      },500);
    },
    checkScrollPosition: function() {
      var _this = VP.videoload;
      var windowTop = $( window ).scrollTop();
      var windowHeight = window.innerHeight;
      var _buffer = -windowHeight/3*2; // X pixels from bottom of screen, start video before the fold to mitigate seeing jitter, start two thirds
      
      var $vidtoload = $(".video-wrap.loading");
      $vidtoload.each(function(i) {          
        if ($(this).offset().top < (windowTop + windowHeight - _buffer)) {
            // console.log("[videoload] play video");
            var _vid =$(this).find("video").get(0);
            _vid.play();
            $(this).removeClass("loading");
            if ($("body").hasClass("paused") || $(this).hasClass("freeze")) {
            _vid.pause();
            }
        }
      });

    },
    // initlazyvideo: function () {
    //   var _this = this;
    //   if ($("video").length == 0) {
    //       return;
    //   }
    //   $("video source").each(function() {
    //     _this.setvideosrc($(this));
    //     if (!$(this).parent().hasClass("reload")) {
    //       $(this).parent().addClass("reload");
    //     }
    //   });

    //   $("video.reload").each(function() {
    //     $videlem = $(this).get(0);
    //     $videlem.load();
    //   });

    // },
    // setvideosrc: function ($source) {
    //   ismobile = VP.helpers.isMobile();
    //   if (ismobile && $source.data("srcmobile") != "") {
    //     $source.attr("src",$source.data("srcmobile"));
    //     console.log("setting srcmobile: " + $source.data("srcmobile"));
    //   }
    //   else if ($source.data("src") != "") {
    //     $source.attr("src",$source.data("src"));
    //     console.log("setting src: " + $source.data("src"));
    //   }
    // }
  };
})(jQuery);
